(function(angular) {
  'use strict';

  angular.module('esn.user-configuration')
    .constant('ESN_USER_CONFIGURATION_DEFAULT_MODULE', 'core');
})(angular);
